import { api } from '@/lib/api'

import { OnboardingSubmitStepDetails } from '../types'

export function submitOnboardingStep(data: OnboardingSubmitStepDetails) {
  return api.post<void>(`/v1/onboarding/step`, data)
}
